// src/services/api/weather.api.ts
import axios from "axios";
import { BASE_URL } from "./apiconfig";

export type TempUnits = "metric" | "imperial";

export interface WeatherConditions {
    temp: number | null;
    feels_like: number | null;
    humidity: number | null;
    wind: number | null;
    code: number;
    icon: string | null;
    label: string | null;
    is_day: boolean;
}

export interface WeatherDay {
    date: string; // local YYYY-MM-DD
    min: number | null;
    max: number | null;
    code: number;
    icon: string | null;
    label: string | null;
}

export interface Weather {
    place: string | null;
    country: string | null;
    units: TempUnits;
    current: WeatherConditions;
    daily: WeatherDay[];
}

export interface LocationResult {
    name: string;
    state: string | null;
    country: string | null;
    lat: number;
    lng: number;
}

/* Both endpoints proxy OpenWeather so the API key stays server-side. Unlike the sibling
   dashboard calls these unwrap the CustomResponses envelope here, because the weather card
   holds its own state rather than going through a Redux reducer that would do it. */

export const getWeather = async (
    token: string | null,
    lat: number,
    lng: number,
    units: TempUnits,
    signal?: AbortSignal,
): Promise<Weather> => {
    try {
        const { data } = await axios.get(`${BASE_URL}/dashboard/weather`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { lat, lng, units },
            signal,
        });
        return data.data;
    } catch (error) {
        console.log("Failed to fetch weather. ", error);
        throw error;
    }
};

export const searchLocations = async (
    token: string | null,
    q: string,
    signal?: AbortSignal,
): Promise<LocationResult[]> => {
    try {
        const { data } = await axios.get(`${BASE_URL}/dashboard/location-search`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { q },
            signal,
        });
        return data.data?.results ?? [];
    } catch (error) {
        console.log("Failed to search locations. ", error);
        throw error;
    }
};
